import {AddCardModal} from 'modals';
import Alert from '@mui/material/Alert';

export const AddPaymentMessage = () => (
    <Alert severity="info">
        <span style={{marginRight: '1em'}}>Please provide a payment method for your account</span>
        <AddCardModal/>
    </Alert>
)
